import type { SidebarSectionSpacerComponent } from "@productlane/api/src/browser"
import { cn } from "@productlane/lib/src/cn"

interface Props {
	component: SidebarSectionSpacerComponent
}

const SpaceMapping: Record<SidebarSectionSpacerComponent["size"], string> = {
	xs: "h-0.5",
	s: "h-1",
	m: "h-1.5",
	l: "h-2",
	xl: "h-3",
}

export function SpacerComponent({ component }: Props) {
	return <div className={cn("w-full", SpaceMapping[component.size])} />
}
